module.exports = {
	"da": {
		"help-tool": {
			"button-text": "Hjælp",
			"support-button": "Få hjælp",
			"support-page": {
				"create-ticket": {
					"title": "Få hjælp",
					"instructions": "Send en anmodning nedenfor, og vi vender tilbage til dig inden for 1 hverdag.",
					"related-content": {
						"title": "Disse kan måske hjælpe dig med at løse dit problem"
					},
					"fields": {
						"mid": {
							"label": "Vælg butik",
							"validation": "Butik skal udfyldes"
						},
						"phoneNumber": {
							"label": "Telefonnummer (valgfrit)"
						},
						"topic": {
							"question": "Hvad drejer dit spørgsmål sig om?",
							"label": "Vælg et emne",
							"validation": "Emne skal vælges",
							"options": {
								"orders": "Ordrer",
								"settlements": "Afregninger",
								"agreements": "Aftaler",
								"others": "Andet"
							}
						},
						"subject": {
							"label": "Genstand",
							"validation": "Genstand skal udfyldes"
						},
						"description": {
							"label": "Meddelelse",
							"validation": "Beskrivelse skal udfyldes"
						},
						"attachment": {
							"label": "Tilføjede vedhæftninger",
							"button": "Overfør",
							"info": "Skærmbilleder vil hjælpe os med at løse problemet hurtigere.",
							"supportedFileTypes": "Understøttede filtyper: .png, .jpg, .pdf",
							"error": "Den samlede filstørrelse må ikke overskride {maxSize} MB"
						}
					},
					"submit": "Indsend anmodning",
					"service-unavailable-error": "Hov! Noget gik galt. Prøv igen om et øjeblik. {link} for hjælp, hvis dette fortsætter.",
					"generic-error": "Vi kunne ikke behandle din anmodning. Vores systemer er ikke på talefod med hinanden i øjeblikket. Prøv at genindlæse, eller kom tilbage senere. {link} for hjælp, hvis dette fortsætter.",
					"contact-link": "kontakt os"
				},
				"view-ticket": {
					"title": "Udført!",
					"details": "Vi har modtaget din anmodning, og vi vender tilbage med et svar inden for 1 hverdag. Her er dine oplysninger:",
					"ticket": "Anmodningsnr. {ticketId}",
					"email": "E-mail: {email}",
					"status": "Du kan spore status på vores supportside.",
					"track": "Spor status"
				}
			},
			"header": {
				"homeLink": "Nulstil"
			},
			"home": {
				"greeting": "Hej {givenName}! Hvordan kan vi hjælpe dig?",
				"topics": "Hvad har du brug for hjælp med?"
			},
			"topics": {
				"expandButton": "Mere"
			},
			"feedback": {
				"title": "Hjalp dette?",
				"optionYes": "Ja, det hjalp",
				"optionNo": "Nej, jeg har brug for mere hjælp",
				"positiveFeedback": "Tak for den positive feedback. Det hjælper os med at give dig mere relevante artikler i fremtiden."
			},
			"freeTextFeedback": {
				"title": "Hjælp os med at blive bedre",
				"placeholder": "Hvorfor fandt du ikke dette indhold hjælpsomt?",
				"submitButton": "Send",
				"feedbackMessage": "Tak for din feedback. Det hjælper os med at give dig mere relevante artikler i fremtiden."
			},
			"relatedContent": {
				"title": "Forbundet indhold"
			},
			"search": {
				"buttonLabel": "Søg",
				"input": "Søg efter artikler ...",
				"loading": "Indlæser ...",
				"results": {
					"contact": "Kan du ikke finde det indhold, du har brug for?",
					"empty": "Beklager, vi fandt ikke nogen resultater for din forespørgsel. Prøv at søge igen efter et andet udtryk.",
					"singleTopicFound": "Vi fandt ét emne",
					"multipleTopicsFound": "Vi fandt {count} emner",
					"singleArticleFound": "Vi fandt ét artikel",
					"multipleArticlesFound": "Vi fandt {count} artikler"
				}
			},
			"contact": {
				"title": "Kontakt os",
				"channelsIntro": "Kontakt os, så vi kan hjælpe dig.",
				"businessDetailsTitle": "Dine forretningsoplysninger",
				"businessDetailsName": "Forretningsnavn",
				"businessDetailsEmail": "E-mail",
				"businessDetailsMid": "Butik-ID",
				"phone": {
					"title": "Ring til os",
					"paragraph": "Du kan ringe til os i åbningstiden på hverdage. Hvis du befinder dig i Sverige eller Storbritannien, kan du også ringe til os i weekenden mellem 10.00-16.00."
				},
				"email": {
					"title": "Send os en e-mail",
					"paragraph": "Send os en e-mail, og vi vil vende tilbage til dig, så snart vi kan."
				}
			},
			"errorBoundary": {
				"title": "Der opstod en fejl",
				"message": "Vi beklager meget, men der opstod en fejl. Du kan klikke på knappen 'Gå tilbage' nedenfor for at gå tilbage til hjælpeværktøjet eller knappen 'Få support' for at kontakte os.",
				"resetButton": "Gå tilbage",
				"errorId": "Fejl-ID: {errorId}"
			},
			"tour": {
				"prev": "Forrige",
				"next": "Næste",
				"done": "Udført"
			},
			"notAvailableMobile": {
				"title": "Ikke tilgængelig",
				"buttonBack": "Tilbage",
				"paragraph": "Dette indhold er ikke tilgængelig på denne enhed. Prøv at åbne på en enhed med en større skærmstørrelse såsom en computer."
			},
			"shareButton": {
				"title": {
					"article": "Del et dybt link til denne artikel",
					"topic": "Del et dybt link til denne emne",
					"tour": "Del et dybt link til denne tur"
				},
				"radioItemHome": "Hjemmeapp",
				"descriptionHome": "Åbner hjælpeartiklen på forhandlerportalens hjemmeside",
				"radioItemCurrent": "Aktuel side",
				"descriptionCurrent": "Åbner hjælpeartiklen på den nuværende side"
			},
			"marketSelector": {
				"whichMarketToContact": "Hvilket marked ønsker du at kontakte?"
			}
		},
		"orientation": {
			"title": "Lær hvordan man laver ..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Hej {name}! 👋 Jeg er din Klarna-assistent.",
				"whatDoYouNeedHelpWithPart2": "I mange tilfælde vil brugen af mig hjælpe med at løse din forespørgsel på mindre end 5 minutter.",
				"whatDoYouNeedHelpWithPart3": "Hvad kan jeg hjælpe dig med i dag?",
				"selectSupportChannel": "Vælg venligst en kanal, du kan kontakte vores supporttjeneste på.",
				"selectPayoutIssue": "Perfekt! Gå videre og vælg et udbetalingsrelateret problem 👇",
				"selectOrderIssue": "Perfekt! Gå videre og vælg et ordrerelateret problem 👇",
				"capturedOrders": "Har du nogle {link1} ordrer?",
				"capturedOrdersLink1": "aktiveret",
				"notPaidOrder": {
					"isScheduleFollowed": "Bliver din {link1} (inklusive udbetalingsforsinkelse) fulgt?",
					"isScheduleFollowedLink1": "udbetalingsplan",
					"isHoldbackOrDebt": "Hvis udbetalingsforsinkelsen er overskredet, så tjek venligst din {link1}. Er der nogen tilbageholdelse eller gæld på grund af returneringer/tilbageførsler?",
					"isHoldbackOrDebtLink1": "seneste udligningsfil"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Bekræft venligst aktiveringsdatoen for de ordrer, du forventede at få udbetalt, og tag din udbetalingsforsinkelse i betragtning. Du kan finde dine ordrer {link1}. Er de ordrer, der forventes udbetalt, aktiveret?",
					"isScheduleFollowedLink1": "Her"
				},
				"changePaymentFrequency": "Har du modtaget mere end 30 aktiverede ordrer per måned over en periode på tre måneder?",
				"whenWillGetPaid": "Udbetalingsdatoen afhænger af din udbetalingsplan og udbetalingsforsinkelsen, der er angivet i din kontrakt (vilkår og betingelser). Hvis du er ikke er sikker på, hvad din udbetalingskonfiguration er, kan du tjekke den i {link1}. Bliver udbetalingsplanen (+udbetalingsforsinkelse) fulgt?",
				"whenWillGetPaidLink1": "Afregninger",
				"thatHelped": "Tak for den positive tilbagemelding, dette hjælper os med at give dig mere relevant hjælp i fremtiden. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Ah, jeg forstår! Har du nogle ikke-aktiverede ordrer?",
					"haveUncapturedOrdersPart2": "Hvis du ikke ved, hvordan du tjekker dette, så gå til {link1}.",
					"haveUncapturedOrdersPart2Link1": "denne side",
					"expirationDateSurpassed": "Er udløbsdatoen blevet overskredet? (typisk 28 dage)",
					"customerCreditPaymentMethod": "Har kunden valgt en kreditbetalingsmetode (faktura, konto, direkte debitering)?",
					"isOrderCaptured": "Er ordren {link1}?",
					"isOrderCapturedLink1": "aktiveret"
				}
			},
			"options": {
				"payout": "Udbetaling",
				"orders": "Ordrer",
				"otherIssue": "Andre problemer",
				"whenPaidOrderNext": "Hvornår bliver jeg betalt næste gang?",
				"notPaidOrder": "Jeg blev ikke betalt",
				"paidWrongAmount": "Jeg fik udbetalt det forkerte beløb",
				"changeHowOftenPaid": "Jeg ønsker at ændre, hvor ofte jeg bliver betalt",
				"dontKnowHowToCaptureOrder": "Jeg ved ikke, hvordan jeg aktiverer en ordre",
				"missedCaptureDeadline": "Jeg glemte aktiveringsdeadlinen",
				"needToRefundAnOrder": "Jeg skal tilbagebetale en ordre",
				"yes": "Ja",
				"no": "Nej",
				"partially": "Delvist",
				"iNeedMoreHelp": "Jeg har brug for mere hjælp",
				"thatHelped": "Det hjalp",
				"contactSupportChannel": "Kontakt supportkanaler"
			},
			"explanations": {
				"noCapturedOrders": "Først og fremmest skal du {link1}. Når du har aktiveret ordren, udbetaler vi beløbet til din bankkonto. Gebyrer, returneringer og andre opkrævninger trækkes fra dette beløb.",
				"noCapturedOrdersLink1": "aktivér en ordre",
				"feesReturnsHoldbacks": "Gebyrer, returneringer og andre opkrævninger kan måske trækkes fra beløbet. Tjek venligst, om du har tilbageholdelse eller gæld på grund af returneringer/tilbageførsler i {link1}.",
				"feesReturnsHoldbacksLink1": "seneste udligningsfil",
				"notPaidOrder": {
					"scheduleFollowed": "Når du har aktiveret en ordre, udbetaler vi beløbet til din bankkonto i henhold til din udbetalingsplan. Gebyrer, returneringer og andre opkrævninger trækkes fra dette beløb. Tjek venligst værdien af din udbetaling i din {link1}.",
					"scheduleFollowedLink1": "seneste udligningsfil",
					"noHoldback": "Bekræft venligst, at du har de rigtige bankkontooplysninger registreret for udbetalingens valuta {link1}.",
					"noHoldbackLink1": "Her",
					"withHoldback": "Hvis værdien af de registrerede ordrer overstiger gælden, skal du kontrollere, at du har de rigtige bankkontooplysninger registreret for udbetalingens valuta {link1}.",
					"withHoldbackLink1": "Her"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Du vil modtage den næste udbetaling i henhold til udbetalingsplanen + udbetalingsforsinkelsen."
				},
				"changePaymentFrequency": {
					"isAble": "Fortsæt venligst ved at kontakte vores support via nedenstående kanaler.",
					"isUnable": "Desværre opfylder du ikke kravene for at ændre din udbetalingsplan."
				},
				"orders": {
					"uncapturedDynamicYes": "Åh, jeg kan se, at du har {number} ikke-aktiverede ordrer.",
					"uncapturedDynamicNo": "Jeg kan se, at du ikke har nogle ikke-aktiverede ordrer",
					"uncapturedYesPart1": "Så er det tid til at du aktiverer nogle ordrer! For at gøre dette,",
					"uncapturedYesPart2": "1. Gå til Ordresiden {link1}.",
					"uncapturesYesPart2Link1": "ved at klikke her",
					"uncapturedYesPart3": "2. Klik på Klarna-referencen for den ordre, du ønsker at aktivere",
					"uncapturedYesPart4": "3. Vælg artiklerne eller tilføj et beløb, du vil aktivere",
					"uncapturedYesPart5": "4. Tryk på “Aktivér”",
					"uncapturedNoPart1": "For at aktivere en ordre skal du først have ordrer, du kan aktivere.",
					"uncapturedNoPart2": "Når du aktiverer en ordre, betyder det, at du bekræfter, at ordren er blevet afsendt til kunden. Dette bør altid gøres samme dag, som ordren afsendes, for hver ordre. Når du aktiverer en ordre, giver du os også besked om, at vi skal udløse en udbetaling til dig for den ordre. Læs mere om, hvordan du aktiverer en ordre {link1}.",
					"uncapturedNoLink1": "Her",
					"customerCreditPaymentMethodNo": "Desværre kan vi ikke forlænge en ordre, der er udløbet. Du er nødt til at gendanne ordren.",
					"expirationDateSurpassedYes": "Lad os hjælpe dig med at forlænge ordren, kontakt venligst vores support via en af nedenstående kanaler.",
					"expirationDateSurpassedNo": "Gå til {link1}. Vælg ordren ved at markere feltet ud for Klarna-referencenummeret. Klik på Udvid udløbsdatoen og bekræft din anmodning.",
					"expirationDateSurpassedNoLink1": "Ordrer > for at aktivere",
					"isOrderCapturedYesPart1": "Vælg varerne, du vil refundere, og klik på Refunder. Du kan også klikke på Refundering først og så indtaste det beløb, du ønsker at refundere – du vælger, hvad der bedst virker for dig.",
					"isOrderCapturedYesPart2": "Din kunde vil modtage tilbagebetaling af det beløb, de allerede har betalt, inden for 2-5 hverdage. Og du vil se dette beløb fratrukket fra din næste udbetaling.",
					"isOrderCapturedNo": "Hvis du har en ikke-aktiveret ordre, som du ikke kan sende, kan du {link1} hele ordren. Gå til {link2} og tryk på annuller ordre.",
					"isOrderCapturedNoLink1": "annuller",
					"isOrderCapturedNoLink2": "ordreside",
					"refundPartiallyCaptured": "Hvis du delvist har aktiveret ordren for varer, du har sendt, og ikke kan opfylde resten, skal du frigive den ikke-aktiverede del af ordren. Gå til {link1}, tryk på Flere handlinger og vælg Frigiv.",
					"refundPartiallyCapturedLink1": "ordreside"
				}
			},
			"messages": {
				"sorryToHearThat": "Beklager, at jeg ikke kunne være behjælpelig. Du vil snart blive omdirigeret, så du kan kontakte vores support."
			},
			"button": {
				"label": "Få hjælp"
			},
			"contact": {
				"chat": "Chat med en medarbejder",
				"ticket": "Indgiv en anmodning",
				"times": {
					"minutes": "Ventetid: {time} minut(ter)",
					"hours": "Ventetid: {time} time(r)",
					"days": "Ventetid: {time} dag(e)"
				}
			}
		}
	}
};